module.exports = __webpack_public_path__ + "img/consultoria@2x.fcd61ab0.png";